import { Schema } from "effect";
import { CopyResponseSchema } from "../shared/api/copy";
import { replaceMessages } from "./en";

export async function refreshRuntimeCopy() {
  try {
    const response = await fetch("/api/copy", {
      headers: { Accept: "application/json" },
      cache: "no-store",
    });
    if (!response.ok) return false;

    const payload = Schema.decodeUnknownSync(CopyResponseSchema)(await response.json());
    const replaced = replaceMessages(payload.messages);
    if (replaced) window.dispatchEvent(new Event("harness:copy-updated"));
    return replaced;
  } catch {
    return false;
  }
}
